module.exports = new __parcel__URL__("login_poster_5.9eb5adcc.png").toString();